import {
  BAlert,
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardGroup,
  BCardText,
  BCardTitle,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormSelectOptionGroup,
  BFormTextarea,
  BFormTimepicker,
  BIcon,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BJumbotron,
  BLink,
  BModal,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavbarToggle,
  BNavItem,
  BNavItemDropdown,
  BPagination,
  BProgress,
  BProgressBar,
  BRow,
  BTab,
  BTable,
  BTabs,
  VBModal,
  VBToggle,
} from 'bootstrap-vue';

export function initBootstrapVue(vue) {
  vue.component('b-avatar', BAvatar);
  vue.component('b-badge', BBadge);
  vue.component('b-card', BCard);
  vue.component('b-card-body', BCardBody);
  vue.component('b-card-group', BCardGroup);
  vue.component('b-card-text', BCardText);
  vue.component('b-card-title', BCardTitle);
  vue.component('b-col', BCol);
  vue.component('b-dropdown', BDropdown);
  vue.component('b-dropdown-item', BDropdownItem);
  vue.component('b-link', BLink);
  vue.component('b-alert', BAlert);
  vue.component('b-modal', BModal);
  vue.component('b-button', BButton);
  vue.component('b-navbar', BNavbar);
  vue.component('b-navbar-nav', BNavbarNav);
  vue.component('b-navbar-brand', BNavbarBrand);
  vue.component('b-navbar-toggle', BNavbarToggle);
  vue.component('b-pagination', BPagination);
  vue.component('b-progress', BProgress);
  vue.component('b-progress-bar', BProgressBar);
  vue.component('b-form', BForm);
  vue.component('b-form-file', BFormFile);
  vue.component('b-form-input', BFormInput);
  vue.component('b-form-group', BFormGroup);
  vue.component('b-form-checkbox', BFormCheckbox);
  vue.component('b-form-select', BFormSelect);
  vue.component('b-form-select-option', BFormSelectOption);
  vue.component('b-form-select-option-group', BFormSelectOptionGroup);
  vue.component('b-form-textarea', BFormTextarea);
  vue.component('b-collapse', BCollapse);
  vue.component('b-nav-item', BNavItem);
  vue.component('b-nav-item-dropdown', BNavItemDropdown);
  vue.component('b-modal', BModal);
  vue.directive('b-modal', VBModal);
  vue.directive('b-toggle', VBToggle);
  vue.component('b-form-datepicker', BFormDatepicker);
  vue.component('b-form-timepicker', BFormTimepicker);
  vue.component('b-input-group', BInputGroup);
  vue.component('b-input-group-append', BInputGroupAppend);
  vue.component('b-input-group-prepend', BInputGroupPrepend);
  vue.component('b-jumbotron', BJumbotron);
  vue.component('b-table', BTable);
  vue.component('b-tabs', BTabs);
  vue.component('b-tab', BTab);
  vue.component('b-row', BRow);
  vue.component('b-container', BContainer);
  vue.component('b-icon', BIcon);
}
